module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Good Psychologist")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0vi-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Henry Holt and Company, LLC"), _c('br'), _c('em', [_vm._v("Publishers since 1866")]), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, New York 10010"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.henryholt.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henryholt.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Henry Holt"), _c('sup', [_vm._v("®")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0vi-02.jpg"
    }
  }), _c('sup', [_vm._v("®")]), _vm._v(" are registered trademarks of"), _c('br'), _vm._v("Henry Holt and Company, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Text copyright © 2010 by Noam Shpancer"), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Distributed in Canada by H. B. Fenn and Company Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Originally published in Hebrew by Yedioth Sefarim, Tel Aviv, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Lyrics from “Long Way Around” by Chris Whitley © 1991 WB MUSIC CORP."), _c('br'), _vm._v("(ASCAP) All Rights Reserved. Used by Permission.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "block-para-s"
  }, [_vm._v("Shpancer, Noam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-s"
  }, [_vm._v("[Psikholog ha-tov. English.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-s"
  }, [_vm._v("The good psychologist : a novel / Noam Shpancer.—1st U.S. ed.")]), _vm._v(" "), _c('p', {
    staticClass: "para2-s"
  }, [_vm._v("   p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-s"
  }, [_vm._v("Originally published in Hebrew as Ha-Psikholog ha-tov by Yedioth Sefarim, Tel Aviv, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-s"
  }, [_vm._v("ISBN: 978-0-8050-9259-2")]), _vm._v(" "), _c('p', {
    staticClass: "para1-ss"
  }, [_vm._v("1. Psychologists—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-s"
  }, [_vm._v("PJ5055.41.P345P7513 2010")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "para1-ss"
  }, [_vm._v("892.4'37—dc22")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "para1-ss"
  }, [_vm._v("2009046566")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Henry Holt books are available for special promotions and premiums. For details contact: Director, Special Markets.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("First U.S. Edition")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Designed by Kelly S. Too")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "center-para1-s"
  }, [_vm._v("1  3  5  7  9  10  8  6  4  2")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "para-s"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0